import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSpacePagepageNews from "../../components/StorageSpace/ViewSpacePageLayer";



const ViewSpacePage= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Storage Space" title2="Storage  Space" link2="/storage-space" />

        {/* AddUserLayer */}
        <ViewSpacePagepageNews />


      </MasterLayout>
    </>
  );
};

export default ViewSpacePage;
